import { Component, OnInit } from '@angular/core';
import { Global } from '../Service/global.service';
import { SharedService } from '../Service/shared.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  langCode ='';
MenuData = [];
MenuNiveau0 = [];
email = '';
oldMail = '';
  constructor(private global:Global,private sharedS:SharedService) { }
  
  ngOnInit(): void {
    this.global.CurentLanguage.subscribe(lg=>{
      this.langCode=lg.code;
      this.sharedS.getMenu(lg.url).subscribe(data=>{
        this.MenuData=data["value"];
        this.MenuNiveau0 = this.getSousMenu(null);
      })
    });
  }
  getSousMenu(id){
    return _.orderBy(this.MenuData.filter(n=>n.ParentId==id), ['Ordre'], ['asc']);
  }   

  goToTop() {
    //@ts-ignore
    AOS.init();
  }




}